import React, {useContext} from 'react';
import IconBase from './IconBase';
import {BrandContext} from "@context/BrandContext";

const WidgetIcon = props => {
    const brandConfig = useContext(BrandContext);
    return (
        <IconBase {...props} defaultTooltipTitle={brandConfig.widgetName} viewBox="0 0 128 128">
            <use xlinkHref="#browser"></use>
            <svg width="40" height="40" viewBox="0 0 128 128" x="32" y="46" className="icon-blue icons-svg">
                <use xlinkHref="#cog"></use>
            </svg>
            <svg width="20" height="20" viewBox="0 0 128 128" x="76" y="74" className="icon-blue icons-svg">
                <use xlinkHref="#cog"></use>
            </svg>
            <use xlinkHref="#browser-finish"></use>
        </IconBase>
    )
}

export default WidgetIcon;